/**
 * @file   src\Pages\EquipmentListing.tsx
 * @brief  Equipment Listing page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useEffect, useNavigate, useState, useLocation, useOutletContext, Container, Table, Button, Breadcrumb, useParams, React } from '../utils/thirdpartyComponents';
import "../styles/subscriptions.scss";
import CWSelect from '../components/CWSelect';
import { pageURLs } from '../utils/pageUrls';
import { AppContextType } from '../interfaces/generalInterface';
import { MessageToaster } from '../utils/toastUtil';
import axios from '../config/axiosConfig';
import { CompanyApi, SubscriptionApi } from '../utils/apiUrls';
import FullLoader from '../components/FullLoader';
import { SubscriptionDataByItem, SubscriptionDetaiByIdlItem } from '../interfaces/subscriptionInterface';
import { ErrorState, LocationItem } from '../interfaces/relayDataInterface';
import { userType } from '../utils/enums';
interface SelectOption {
    value: number;
    label: string;
}

const AddRelayNumber = (props: any) => {

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();

    const options = [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },

    ];

    // To get path from which redirection was done
    const location = useLocation();
    const origin = location.state?.origin || 'Unknown';

    const query = new URLSearchParams(location.search);
    const subscription_type = location.state?.type ||  'month'
    // query.get('type') || 'month';
    const baySubscriptionType = query.get('baySubscriptionType') ?? '0'

    const [relayData, setRelayData] = useState<SubscriptionDataByItem[]>([])

    const [selectedRelays, setSelectedRelays] = useState({});

    const [error, setError] = useState<ErrorState>({});

    const [loading, setLoading] = useState(false);
    // const subscription

    // State to handle company details
    const [company, setCompany] = useState({
        companyName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: ""
    });

    const param = useParams();

    const toaster = new MessageToaster();

    const navigate = useNavigate()

    useEffect(() => {
        getSubscriptionDetails()
        getCompanyAddress()
    }, [])


    useEffect(() => {
        // To display heading
        handleUpdate()
    }, [company])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: props.userType !== userType["CARWASH-OWNER"] ? company.companyName : "Relay Details", url: props.userType !== userType["CARWASH-OWNER"] ? `/superadmin/${pageURLs.manage_subscriptions}/${param.id}?type=${subscription_type}&bayType=${baySubscriptionType}` : `/${pageURLs.manage_subscriptions}?type=${subscription_type}&bayType=${baySubscriptionType}`, showBackButton: true, showMainMenu: true, activeLink: props.userType !== userType["CARWASH-OWNER"] ? "manage-car-wash" : "manage-subscriptions" });
    };

    // To get company details
    const getCompanyAddress = async () => {
        try {
            const id = param.id ? parseInt(param.id) : 0;
            const { data } = (props.userType !== userType["CARWASH-OWNER"]) ?
                await axios.get(CompanyApi.GET_COMPANY_ADDRESS + id)
                :
                await axios.get(CompanyApi.CARWASH_OWNER_COMPANY_ADDRESS)
            if (data?.error === 0) {
                setCompany(data.data);
            }
            setLoading(false)
        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }


    const getSubscriptionDetails = async () => {
        try {
            setLoading(true); // Show loader
console.log(param.subscription_id);
            const { data } = (props.userType !== userType["CARWASH-OWNER"]) ?
                await axios.get(SubscriptionApi.GET_RELAY_DETAILS + param.subscription_id)
                :
                await axios.get(SubscriptionApi.CARWASH_OWNER_GET_RELAY_DETAILS + param.subscription_id);
            if (data?.error === 0 && Array.isArray(data?.data)) {
                const subscription_list: SubscriptionDetaiByIdlItem[] = data.data;

                // Check if location_list is empty
                if (subscription_list.length > 0) {
                    // Transform the array to match the structure of the Location interface
                    const transformedArray: SubscriptionDataByItem[] = subscription_list.map(item => ({
                        car_wash_location: item.LocationName,
                        subscription_type: item.SubscriptionType === 1 ? "Single" : "Monthly",
                        wash_name: item.WashName,
                        wash_number: item.NumberOfWashes,
                        location_id: item.LocationID,
                        relay_number: item.RelayNumber,
                        wash_time : item.WashTime
                    }));

                    setRelayData(transformedArray);
                } else {
                    console.log('Subscription list is empty');
                    setRelayData([]);  // Set to an empty array if subscription_list is empty
                }
            } else {
                console.log('Subscription list is not available or is not an array');
                setRelayData([]);  // Set to an empty array if data is not available
            }

        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
        }
    }


    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }


    // On selecting relay numbers update state
    const handleSelectChange = (index: number, selectedOption: SelectOption, item: SubscriptionDataByItem) => {
        // Update the relay number in relayData
        const updatedRelayData = [...relayData];
        updatedRelayData[index].relay_number = selectedOption.value;
        setRelayData(updatedRelayData);

        // Clear any previous error for this row
        setError(prev => ({ ...prev, [index]: { message: '' } }));

        setSelectedRelays((prevSelectedRelays) => ({
            ...prevSelectedRelays,
            [index]: {
                relayNumber: selectedOption.value,
                location_id: item.location_id

            }

        }));
    };

    const validateRelayNumbers = (): boolean => {
        let isValid = true;
        const errors: ErrorState = {};

        relayData.forEach((item, index) => {
            if (!item.relay_number) {
                isValid = false;
                errors[index] = { message: 'Relay number is required.' };
            }
        });

        setError(errors);
        return isValid;
    };

    const saveRelayNumber = async () => {
        // Update selectedRelays to required format 
        const locations = Object.values(selectedRelays).map((item) => {
            const locationItem = item as LocationItem; // Type assertion
            return {
                locationId: locationItem.location_id,
                relayNumber: locationItem.relayNumber
            }
        });

        try {

            if (validateRelayNumbers()) {

                const newRelayData = {
                    subscriptionId: param.subscription_id ? parseInt(param.subscription_id) : 0,
                    locations: locations
                }

                try {
                    const { data } = (props.userType !== userType["CARWASH-OWNER"]) ?
                        await axios.post(
                            subscription_type === "buyups"
                                ? SubscriptionApi.SAVE_BUY_UP_RELAY_NUMBER
                                : SubscriptionApi.SAVE_RELAY_NUMBER,
                            newRelayData
                        )
                        :
                        await axios.post(
                            subscription_type === "buyups"
                                ? SubscriptionApi.CARWASH_OWNER_SAVE_BUY_UP_RELAY_NUMBER
                                : SubscriptionApi.CARWASH_OWNER_SAVE_RELAY_NUMBER,
                            newRelayData
                        )

                    if (data?.error === 0) {

                        //Navigate to manage subscription page
                        if (props.userType !== userType["CARWASH-OWNER"]) {
                            navigate(`/superadmin/${pageURLs.manage_subscriptions}/${param.id}?bayType=${baySubscriptionType}&type=${subscription_type}`);
                        } else {
                            navigate(`/${pageURLs.manage_subscriptions}?bayType=${baySubscriptionType}&type=${subscription_type}`);
                        }
                    }
                    else {
                        // show error message
                        toaster.toastError(data?.message);
                    }
                } catch (error: any) {
                    throw new Error(error?.response?.data?.message || error?.message);
                }
            }



        } catch (error: any) {
            throw new Error(error?.response?.data?.message || error?.message);

        }
    }

    const breadcrumbText =
        relayData[0]?.subscription_type === 'Single'
            ? 'Manage Single Wash'
            : 'Manage Subscriptions';

    const breadcrumbClickHandler = () =>
        props.userType !== userType["CARWASH-OWNER"]
            ? itemClick(`/superadmin/${pageURLs.manage_subscriptions}/${param.id}?type=${subscription_type}&bayType=${baySubscriptionType}`)
            : itemClick(`/${pageURLs.manage_subscriptions}?type=${subscription_type}&bayType=${baySubscriptionType}`);

    return (

        <div className='manage-carwash-container manage-subscription-container'>
            <Container>
                <Breadcrumb>
                    {props.userType !== userType["CARWASH-OWNER"] ?
                        <>
                            <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_carwash}`) }}>Manage Car Washes</Breadcrumb.Item>
                            <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.carwash_locations}/${param.id}`) }}> {company.companyName}</Breadcrumb.Item>
                        </> : null}

                    <Breadcrumb.Item onClick={breadcrumbClickHandler}>
                        {breadcrumbText}
                    </Breadcrumb.Item>

                    <Breadcrumb.Item active>{origin === "manage-subscription" ? "View Relay Details" : "Add Relay Number"}</Breadcrumb.Item>
                </Breadcrumb>

                <div className="cw-table-wrap tbl-visible">
                    <Table responsive className='m-0'>
                        <thead>

                            <tr>
                                <th>Car Wash Location</th>
                                <th>Subscription Type</th>
                                <th>Wash Name</th>
                                {parseInt(baySubscriptionType) == 0 ? <th>No. of Washes</th> :<th>Usage Time</th> }
                               
                                <th>Relay Number</th>
                            </tr>
                        </thead>
                        <tbody>

                            {relayData.map((item, index) => (
                                <tr key={(index)}>
                                    <td>{item.car_wash_location}</td>
                                    <td>{item.subscription_type}</td>
                                    <td>{item.wash_name}</td>
                                    {parseInt(baySubscriptionType) == 0 ? <td>{item?.wash_number}</td> :<td>{item?.wash_time}</td>}
                                    
                                    <td>
                                        <CWSelect
                                            id="relaynumber"
                                            name="relaynumber"
                                            options={options}
                                            dropdownGap={0}
                                            dropdownPosition="auto"
                                            className="hide-input"
                                            multi={false}
                                            errorMessage={error[index]?.message && error[index].message}
                                            values={options.filter(option => option.value === item.relay_number)}
                                            onChange={(selected) => handleSelectChange(index, selected[0], item)}
                                            isMandatory
                                        />
                                    </td>
                                </tr>
                            ))}


                        </tbody>
                    </Table>
                </div>
                <div className="table-btn-action text-end">
                    <Button title='Save' variant="primary" className="primary-btn" onClick={() => saveRelayNumber()}>Save</Button>
                </div>

            </Container>

            {loading && <FullLoader />}

        </div>
    )
}

export default AddRelayNumber;
